import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SectionHead, Reveal } from "@/components/ui/motion";
import { TeamGrid } from "@/components/sections/TeamGrid";

export const ConsultantStrip = () => (
  <section className="relative overflow-hidden py-20 sm:py-28 lg:py-32" data-testid="home-consultants">
    <div className="grid-lines absolute inset-0 opacity-30 [mask-image:radial-gradient(ellipse_at_top_right,black,transparent_65%)]" aria-hidden="true" />
    <div className="wrap relative">
      <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
        <SectionHead
          eyebrow="Tim Konsultan"
          title={<>Pilih konsultan, <span className="serif-it font-normal text-accentb">langsung ajak bicara.</span></>}
          desc="Klik foto untuk melihat profil, atau tekan nomor WhatsApp untuk langsung chat dengan konsultan pilihan Anda. Percakapan bersifat rahasia."
        />
        <Reveal delay={0.1}>
          <Link to="/konsultan" className="btn btn-ghost" data-testid="home-consultants-all">Halaman tim konsultan <ArrowUpRight size={16} /></Link>
        </Reveal>
      </div>
      <Reveal className="mt-12"><TeamGrid filter /></Reveal>
    </div>
  </section>
);
